/// <amd-module name="Wiki/CloneDialog/CloneWikiDialog" />
import * as React from "react";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { CustomDialog } from "VSSUI/Dialog";

import * as Resources from "Wiki/CloneDialog/Resources";
import { GitRepositoryData } from "Wiki/ViewCommon/Contracts";
import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { WikiDataProviderData } from "Wiki/ViewCommon/Contracts";
import { WikiDataProviderContributionId } from "Wiki/ViewCommon/Constants";
import { publish } from "Wiki/ViewCommon/Utils/WikiHelper";

export interface CloneWikiDialogProps {
    wikiRepositoryData: GitRepositoryData;
    onDismiss: () => void;
}

export class CloneWikiDialog extends VssComponent<CloneWikiDialogProps> {
    private _copyButton: Element | null;
    private _contributionService: IVssContributionService;

    constructor(props: CloneWikiDialogProps, context: IVssComponentContext) {
        super(props, context);

        this._contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
    }

    public render(): JSX.Element {
        const repoData = this.props.wikiRepositoryData;
        return (
            <CustomDialog onDismiss={this.props.onDismiss} modal={true}>
                <LegacyComponent
                    modules={["VersionControl/Scenarios/NewGettingStarted/GettingStartedView"]}
                    wrappedType="vcGettingStartedView"
                    wrappedProps={{
                        isCloneExperience: true,
                        showOnlyCommandLine: true,
                        heading: Resources.CloneRepositoryText,
                        cloneUrl: repoData.cloneUrl,
                        sshEnabled: repoData.sshEnabled,
                        sshUrl: repoData.sshUrl,
                        repository: repoData.repository,
                        accountTokenExpirationDays: this._getTokenExpirationDays()
                    }}
                    wrappedRef={this._dialogRef}
                />
            </CustomDialog>
        );
    }

    private _dialogRef = (ref: HTMLElement | null): HTMLElement | null => {
        if (ref) {
            this._copyButton = document.querySelector("#clone-section-in-popup .pivoted-textbox-with-copy-container button.copy-button");
            if (this._copyButton) {
                this.addEventListener(this._copyButton, "click", this._publishCopyCloneUrlClicked);
            }
        }

        return ref;
    };

    private _publishCopyCloneUrlClicked = (): void => {
        publish(this.context.pageContext, TelemetryConstants.CopyCloneUrlClicked);
    };

    private _getTokenExpirationDays(): string | undefined {
        const data = this._contributionService.getData<WikiDataProviderData>(WikiDataProviderContributionId);
        return !!data && !!data.accountTokenExpirationDays ? data.accountTokenExpirationDays : undefined;
    }
}

VssComponent.register("Wiki.CloneWikiDialog", CloneWikiDialog);
